'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyMachine = require('@metaplex-foundation/mpl-candy-machine');
var Account = require('../../types/Account.cjs');

/** @group Accounts */

/** @group Account Helpers */
const parseCandyMachineV2Account = Account.getAccountParsingFunction(mplCandyMachine.CandyMachine);

/** @group Account Helpers */
const toCandyMachineV2Account = Account.getAccountParsingAndAssertingFunction(mplCandyMachine.CandyMachine);

/** @group Accounts */

/** @group Account Helpers */
const parseCandyMachineV2CollectionAccount = Account.getAccountParsingFunction(mplCandyMachine.CollectionPDA);

/** @group Account Helpers */
const toCandyMachineV2CollectionAccount = Account.getAccountParsingAndAssertingFunction(mplCandyMachine.CollectionPDA);

exports.parseCandyMachineV2Account = parseCandyMachineV2Account;
exports.parseCandyMachineV2CollectionAccount = parseCandyMachineV2CollectionAccount;
exports.toCandyMachineV2Account = toCandyMachineV2Account;
exports.toCandyMachineV2CollectionAccount = toCandyMachineV2CollectionAccount;
//# sourceMappingURL=accounts.cjs.map
